import { render } from "./ProvinceTaskAttachmentOffcanvas.vue?vue&type=template&id=f00fccc0&scoped=true&ts=true"
import script from "./ProvinceTaskAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProvinceTaskAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./ProvinceTaskAttachmentOffcanvas.scss?vue&type=style&index=0&id=f00fccc0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00fccc0"]])

export default __exports__